module.exports = __webpack_public_path__ + "img/hero.6a962cc0.jpg";